/**
 * Shared rules for Additional Information panel (customer PO + mandatory metadata).
 * Used by useCheckoutPanels (panel error state) and useCheckoutOrder (submit validation).
 */
import type { CheckoutState } from "./types";

type MetadataListEntry = { metadata_id: string; mandatory?: number };

export function getMissingMandatoryMetadataIds(
  metadataList: Record<string, MetadataListEntry> | undefined,
  orderMetadata: CheckoutState["order_metadata"]
): string[] {
  if (!metadataList) return [];
  return Object.values(metadataList)
    .filter(
      (m) =>
        Number(m.mandatory) === 1 &&
        !(orderMetadata[m.metadata_id]?.value ?? "")
    )
    .map((m) => m.metadata_id);
}

/** True when customer PO or any mandatory metadata field is missing. */
export function checkoutAdditionalInfoHasErrors(
  entityFromContext: Record<string, unknown> | undefined,
  customerPo: string,
  orderMetadata: CheckoutState["order_metadata"]
): boolean {
  if (!entityFromContext) return false;
  const poRequired =
    entityFromContext.collect_customer_po === "REQUIRED" && !customerPo;
  if (poRequired) return true;
  return (
    getMissingMandatoryMetadataIds(
      entityFromContext.metadata_list as
        | Record<string, MetadataListEntry>
        | undefined,
      orderMetadata
    ).length > 0
  );
}
